import { Api } from '../base/Api';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class OfferApi extends Api<any> {
}
